var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGettingReadyPageAfterTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_364_116607",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0004 0H0V50.0002H50.0004V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_364_116607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4121 45H12.4121C11.0314 45 9.91211 46.1193 9.91211 47.5C9.91211 48.8807 11.0314 50 12.4121 50H37.4121C38.7928 50 39.9121 48.8807 39.9121 47.5C39.9121 46.1193 38.7928 45 37.4121 45Z",
    fill: "#428DFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91992 -0.000387359C5.91992 -0.000454618 5.91992 -0.000488281 7.91517 -0.000488281C9.91042 -0.000488281 9.91042 -0.000454618 9.91042 -0.000387359V17.4855C9.91042 25.5183 16.4226 32.0305 24.4568 32.0305C32.4911 32.0305 39.0033 25.5183 39.0033 17.4855V0.000418815C39.0033 0.000351556 39.0033 -0.000488281 40.9985 -0.000488281C42.9938 -0.000488281 42.9938 -0.000454618 42.9938 -0.000387359V17.4855C42.9938 27.7224 34.6947 36.021 24.4568 36.021C14.2189 36.021 5.91992 27.7224 5.91992 17.4855V-0.000387359Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6367 50H32.3129V49.0421C32.3129 44.9894 29.0277 41.7041 24.9748 41.7041C20.9219 41.7041 17.6367 44.9894 17.6367 49.0421V49.9991L14.3129 50V49.0421C14.3129 43.1537 19.0862 38.3803 24.9748 38.3803C30.8634 38.3803 35.6367 43.1537 35.6367 49.0421V50Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0566406 5.97725C0.0566406 2.70425 2.70482 0.0480957 5.98078 0.0480957H7.91932V1.95036H5.98078C3.75799 1.95036 1.9589 3.75225 1.9589 5.97725V5.9792C1.9589 8.2042 3.75799 10.0061 5.98078 10.0061H7.9187L7.91931 11.9083H5.98078C2.70482 11.9083 0.0566406 9.25219 0.0566406 5.9792V5.97725Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9824 5.97713C49.9824 2.7022 47.3271 0.046875 44.0518 0.046875H42.1034L42.1026 1.95134H44.0518C46.2754 1.95134 48.078 3.75407 48.078 5.97713V5.97908C48.078 8.20214 46.2754 10.0049 44.0518 10.0049H42.1034L42.1026 11.9093H44.0518C47.3271 11.9093 49.9824 9.25401 49.9824 5.97908V5.97713Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4635 17.0142C37.4635 13.5657 36.0929 10.2587 33.6689 7.82171C31.2304 5.38326 27.9117 4.01392 24.4776 4.01392H24.4628C21.0144 4.01392 17.7107 5.38326 15.2723 7.82171C12.8338 10.2587 11.4629 13.5657 11.4629 17.0142C11.4629 20.4627 12.8338 23.7683 15.2723 26.2068C17.7107 28.6453 21.0144 30.0145 24.4628 30.0145H24.4776C27.9117 30.0145 31.2304 28.6453 33.6689 26.2068C36.0929 23.7683 37.4635 20.4627 37.4635 17.0142Z",
    fill: "#9E007E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2849 13.2904C29.6753 12.8998 30.3084 12.8996 30.6991 13.29C31.0897 13.6804 31.0899 14.3136 30.6995 14.7042L29.9922 13.9973L29.2849 13.2904ZM20.6226 20.0111C21.2528 20.6465 22.1191 21.0003 23.0019 21.0003C23.8993 21.0003 24.7505 20.6436 25.3845 20.0182L25.3887 20.0139C26.424 18.9802 27.7517 17.6527 28.8205 16.5838L30.6995 14.7042L29.9922 13.9973L29.2849 13.2904L27.4063 15.1696C26.3383 16.2377 25.0123 17.5635 23.9779 18.5963C23.7121 18.8577 23.3637 19.0003 23.0019 19.0003C22.6452 19.0003 22.2921 18.8545 22.0423 18.6024L22.0407 18.6008C21.6945 18.2531 21.3585 17.9176 21.1093 17.6692L20.6972 17.2591C20.3052 16.87 19.6715 16.8719 19.2824 17.2639C18.8934 17.6558 18.8957 18.289 19.2877 18.6781L19.6974 19.0857C19.9454 19.3329 20.2791 19.6661 20.6226 20.0111Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGettingReadyPageAfterTest);
export default __webpack_public_path__ + "static/media/gettingReadyPage--after-test.c41980bd0aa7d93a523b6661d3006e0f.svg";
export { ForwardRef as ReactComponent };